import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { CodeReferenceBlockHighlight } from "models/interfaces/code-reference-block-highlights/code-reference-block-hightlight";
import { HighlightColor } from "utilities/enumerations/highlight-color";

const defaultValues: CodeReferenceBlockHighlight =
    RecordUtils.auditableDefaultValuesFactory<CodeReferenceBlockHighlight>({
        configurationId: undefined,
        startingSectionId: undefined,
        endingSectionId: undefined,
        startingSectionOffset: undefined,
        endingSectionOffset: undefined,
        highlightColor: HighlightColor.Yellow,
        note: "",
        sortIndex: 0,
    });

export class CodeReferenceBlockHighlightRecord
    extends Record(defaultValues)
    implements CodeReferenceBlockHighlight
{
    constructor(params?: Partial<CodeReferenceBlockHighlight>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        super(params);
    }

    public with(
        values: Partial<CodeReferenceBlockHighlight>
    ): CodeReferenceBlockHighlightRecord {
        return new CodeReferenceBlockHighlightRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
